import React from 'react';

import { ReloadOutlined } from '@ant-design/icons';
import { Breadcrumb, Button } from 'antd';
import styled from 'styled-components';

import { formatTaskDateTime } from 'utils/tasks';

const Header = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`;

const StyledBreadcrumb = styled(Breadcrumb)`
  span {
    color: var(--text-primary);
  }
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const TitleIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--competitor-purple);
  box-shadow: 0 2px 4px var(--box-shadow-pink);
`;

const TitleIconImage = styled.img`
  width: 20px;
  height: 20px;
`;

const Title = styled.span`
  font-family: var(--font-bold);
  font-size: 40px;
  line-height: 40px;
`;

const PageDescription = styled.span`
  color: var(--text-secondary);
  font-size: 13px;
`;

const HeaderMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
`;

const LastUpdated = styled.span`
  color: var(--text-secondary);
  font-size: 12px;
`;

type Props = {
  isFetching: boolean;
  lastUpdated?: string;
  onRefresh: () => void;
};

const TaskQueueHeader = ({ isFetching, lastUpdated, onRefresh }: Props) => (
  <Header>
    <HeaderContent>
      <StyledBreadcrumb items={[{ title: 'Administration' }]} separator="·" />
      <TitleRow>
        <TitleIcon>
          <TitleIconImage src="/icons/lock.svg" alt="Task Queue" />
        </TitleIcon>
        <Title>Task Queue</Title>
      </TitleRow>
      <PageDescription>
        Intended for monitoring the Huey task queue and worker activity, not for general task tracking.
      </PageDescription>
    </HeaderContent>
    <HeaderMeta>
      <Button icon={<ReloadOutlined />} loading={isFetching} onClick={onRefresh}>
        Refresh status
      </Button>
      <LastUpdated>Last updated {formatTaskDateTime(lastUpdated)}</LastUpdated>
    </HeaderMeta>
  </Header>
);

export default TaskQueueHeader;
